<template>
  <div class="ml-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card icon="mdi-account-outline">
          <template v-slot:after-heading>
            <div class="title font-weight-light">
              <span class="body-1">ДТП - </span>
              <v-spacer />
              <span class="body-2">{{ title }}
                <v-icon
                  v-if="view && form.id!=null"
                  @click="$router.push('/accident/change/' + form.id)"
                >mdi-pencil</v-icon>
                <v-icon
                  v-if="change && form.id!=null"
                  @click="$router.push('/accident/view/' + form.id)"
                >mdi-eye</v-icon>
              </span>
            </div>
          </template>
          <base-material-tabs
            class="mx-auto"
          >
            <v-tab
              v-for="(tab, i) in this.tabs"
              :key="i"
            >
              {{ tab }}
            </v-tab>

            <v-tab-item>
              <form>
                <v-row>
                  <v-col
                    v-if="view"
                    cols="12"
                  >
                    <span v-if="form.commissar"> {{ form.commissar.surname }} {{ form.commissar.name }} {{ form.commissar.patronymic }}</span>
                  </v-col>
                  <v-col
                    v-if="!view"
                    cols="12"
                  >
                    <v-select

                      v-model="form.commissar"
                      :items="select.users"
                      label="Выберите комиссара"
                      :disabled="view"
                    >
                      <template v-slot:selection="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                      <template v-slot:item="{item}">
                        <v-list>
                          <v-list-item-content>
                            <v-list-item-title> {{ item.surname }} {{ item.name }} {{ item.patronymic }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.common.address"
                      v-validate="'required'"
                      color="secondary"
                      label="Адрес события"
                      prepend-icon="mdi-map-marker"
                      validate-on-blur
                      name="common_address"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.common.date"
                      v-validate="'required'"
                      color="secondary"
                      type="date"
                      label="Дата события"
                      prepend-icon="mdi-calendar"
                      validate-on-blur
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.common.time"
                      v-validate="'required'"
                      color="secondary"
                      type="time"
                      label="Время события"
                      prepend-icon="mdi-calendar-clock"
                      validate-on-blur
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.common.count.cars"
                      color="secondary"
                      data-vv-name="count.cars"
                      label="Количество поврежденных ТС"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                    <v-text-field
                      v-model="form.common.count.wounded"
                      :error-messages="errors.collect('about.count.wounded')"
                      color="secondary"
                      data-vv-name="count.wounded"
                      label="Раненых"
                      :disabled="view"
                    />
                    <v-text-field
                      v-model="form.common.count.dead"
                      :error-messages="errors.collect('about.count.dead')"
                      color="secondary"
                      data-vv-name="count.dead"
                      label="Погибших"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox
                      v-model="form.common.drunken"
                      color="secondary"
                      data-vv-name="drunken"
                      label="Нетрезвое состояние"
                      :disabled="view"
                    />
                    <v-checkbox
                      v-model="form.common.other_car_damage"
                      color="secondary"
                      data-vv-name="other_car_damage"
                      label="Ущерб другим ТС"
                      :disabled="view"
                    />
                    <v-checkbox
                      v-model="form.common.other_damage"
                      color="secondary"
                      data-vv-name="other_damage"
                      label="Ущерб другому имуществу"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox
                      v-model="form.common.inspector"
                      color="secondary"
                      label="Наличие сотрудника ГИБДД"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox
                      v-model="form.common.witness_exists"
                      color="secondary"
                      label="Есть свидетели ДТП"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-if="form.common.inspector"
                      v-model="form.common.inspector_number"
                      color="secondary"
                      label="Номер нагрудного значка"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-if="form.common.witness_exists"
                      v-model="form.common.witness"
                      color="secondary"
                      label="Свидетели"
                      :disabled="view"
                      @input="()=>form.common.witness=form.common.witness.toUpperCase()"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="form.common.scheme"
                      label="Схема ДТП прилагается"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item>
              <v-form
                v-model="valid.first.vehicle"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.first.vehicle.model"
                      required
                      :rules="[(v) => !!v || 'Заполните поле']"
                      color="secondary"
                      label="Марка транспортного средства"
                      prepend-icon="mdi-car"
                      type="text"
                      :disabled="view"
                      @input="()=>form.first.vehicle.model = form.first.vehicle.model.toUpperCase()"
                    />
                  </v-col>
                  <v-col
                    v-if="!form.first.vehicle.without_vin"
                    cols="8"
                    md="8"
                  >
                    <v-text-field

                      v-model="form.first.vehicle.vin"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]{17}$/.test(v) || 'VIN должен состоять только из латинских букв и цифр']"
                      required
                      color="secondary"
                      label="VIN"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      :disabled="view"
                      @input="()=>form.first.vehicle.vin = form.first.vehicle.vin.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col
                    v-if="form.first.vehicle.without_vin"
                    cols="8"
                    md="8"
                  >
                    <v-text-field
                      v-model="form.first.vehicle.body"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]+$/.test(v) || 'Номер кузова должен состоять только из латинских букв и цифр']"
                      required
                      color="secondary"
                      label="Номер кузова"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      :disabled="view"
                      @input="()=>form.first.vehicle.body = form.first.vehicle.body.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.first.vehicle.without_vin"
                      color="secondary"
                      label="VIN отсутствует"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.first.vehicle.number"
                      :disabled="form.first.vehicle.without_number || view"
                      color="secondary"
                      label="Госномер"
                      prepend-icon="mdi-barcode-scan"
                      @input="()=>form.first.vehicle.number = form.first.vehicle.number.toUpperCase()"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.first.vehicle.without_number"
                      color="secondary"
                      label="Отсутствует"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.first.vehicle.date"
                      required
                      color="secondary"
                      type="number"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      label="Год выпуска ТС"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="form.first.vehicle.doc_type"
                      required
                      :rules="[(v) => !!v || 'Заполните поле']"
                      :items="dict.doc_type"
                      color="secondary"
                      label="Тип документа"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.first.vehicle.doc.series"
                      required
                      :counter="4"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение!']"
                      color="secondary"
                      label="Серия документа"
                      prepend-icon="mdi-file-document-box"
                      maxlength="4"
                      :disabled="view"
                      @input="()=>form.first.vehicle.doc.series = form.first.vehicle.doc.series.toUpperCase().substring(0,4)"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.first.vehicle.doc.number"
                      required
                      :counter="6"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{6}$/.test(v) || 'Неверное значение']"
                      color="secondary"
                      label="Номер документа"
                      maxlength="6"
                      :disabled="view"
                      @input="()=>form.first.vehicle.doc.number = form.first.vehicle.doc.number.toUpperCase().substring(0,6)"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.first.vehicle.doc.date"
                      type="date"
                      label="Дата выдачи"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox
                      v-model="form.first.vehicle.can_move"
                      color="secondary"
                      label="Может ли передвигаться своим ходом?"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-if="!form.first.vehicle.can_move"
                      v-model="form.first.vehicle.cause"
                      color="secondary"
                      label="Почему нет?"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-tab-item>

            <v-tab-item>
              <form>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="form.first.owner.surname"
                      v-validate="'required'"
                      color="secondary"
                      label="Фамилия собственника"
                      prepend-icon="mdi-account"
                      validate-on-blur
                      :disabled="view"
                      @input="()=>form.first.owner.surname=form.first.owner.surname.toUpperCase()"
                    />

                    <v-text-field
                      v-model="form.first.owner.name"
                      v-validate="'required'"
                      color="secondary"
                      label="Имя собственника"
                      prepend-icon="mdi-account"
                      validate-on-blur
                      :disabled="view"
                      @input="()=>form.first.owner.name=form.first.owner.name.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.first.owner.patronymic"
                      v-validate="'required'"
                      color="secondary"
                      label="Отчество собственника"
                      prepend-icon="mdi-account"
                      validate-on-blur
                      :disabled="view"
                      @input="()=>form.first.owner.patronymic=form.first.owner.patronymic.toUpperCase()"
                    />
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.first.owner.phone"
                        color="secondary"
                        type="number"
                        label="Телефон"
                        :counter="11"
                        maxlength="11"
                        :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                        prepend-icon="mdi-face"
                        :mask="'+7(###)###-##-##'"
                        :disabled="view"
                      />
                    </v-col>
                    <v-text-field
                      v-model="form.first.owner.address"
                      v-validate="'required'"
                      name="first_owner_address"
                      color="secondary"
                      label="Адрес регистрации"
                      prepend-icon="mdi-home-account"
                      validate-on-blur
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item class="pb-12">
              <form>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-checkbox
                      v-model="form.first.driver.as_owner"
                      v-validate="'required'"
                      color="secondary"
                      label="Водитель является собственником ТС"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      :disabled="view"
                    />
                    <v-text-field
                      v-model="form.first.driver.surname"
                      v-validate="'required'"
                      :disabled="form.first.driver.as_owner || view"
                      color="secondary"
                      label="Фамилия"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.first.driver.surname=form.first.driver.surname.toUpperCase()"
                    />

                    <v-text-field
                      v-model="form.first.driver.name"
                      v-validate="'required'"
                      :disabled="form.first.driver.as_owner || view"
                      color="secondary"
                      label="Имя"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.first.driver.name=form.first.driver.name.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.first.driver.patronymic"
                      v-validate="'required'"
                      :disabled="form.first.driver.as_owner || view"
                      color="secondary"
                      label="Отчество"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.first.driver.patronymic=form.first.driver.patronymic.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.first.driver.address"
                      v-validate="'required'"
                      name="first_driver_address"
                      :disabled="form.first.driver.as_owner || view"
                      color="secondary"
                      label="Адрес"
                      prepend-icon="mdi-home"
                      validate-on-blur
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.first.driver.birthday"
                      color="secondary"
                      label="Дата рождения"
                      type="date"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.first.driver.phone"
                      color="secondary"
                      type="number"
                      label="Телефон"
                      :counter="11"
                      maxlength="11"
                      :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                      prepend-icon="mdi-face"
                      :mask="'+7(###)###-##-##'"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    Данные о водительском удостоверении
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.first.driver.driver_doc.series"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      color="secondary"
                      label="Серия ВУ"
                      :counter="4"
                      maxlength="4"
                      prepend-icon="mdi-car"
                      :disabled="view"
                      @input="()=>form.first.driver.driver_doc.series = form.first.driver.driver_doc.series.toUpperCase().substring(0,4)"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.first.driver.driver_doc.number"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{6}$/.test(v) || 'Неверное значение']"
                      :counter="6"
                      maxlength="6"
                      color="secondary"
                      label="Номер ВУ"
                      :disabled="view"
                      @input="()=>form.first.driver.driver_doc.number = form.first.driver.driver_doc.number.toUpperCase().substring(0,6)"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.first.driver.driver_doc.date"
                      color="secondary"
                      label="Дата выдачи"
                      type="date"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="form.first.driver.category"
                      :items="dict.category"
                      color="secondary"
                      label="Категория"
                      multiple
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item>
              <form>
                <v-row>
                  <v-col cols="8">
                    <v-select
                      v-model="form.first.insurance.insurer"
                      :items="dict.insurer"
                      color="secondary"
                      label="Страховая"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      :disabled="view"
                      color="primary"
                      max-width="100"
                      @click="dialog.insurer.show = true"
                    >
                      Добавить
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.first.insurance.doc.series"
                      color="secondary"
                      label="Серия"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{3}$/.test(v) || 'Неверное значение']"
                      prepend-icon="mdi-car"
                      :counter="3"
                      maxlength="3"
                      :disabled="view"
                      @input="()=>form.first.insurance.doc.series = form.first.insurance.doc.series.toUpperCase().substring(0,3)"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.first.insurance.doc.number"
                      color="secondary"
                      label="Номер полиса"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{10}$/.test(v) || 'Неверное значение']"
                      :counter="10"
                      maxlength="10"
                      :disabled="view"
                      @input="()=>form.first.insurance.doc.number = form.first.insurance.doc.number.toUpperCase().substring(0,10)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.first.insurance.doc.from_date"
                      color="secondary"
                      type="date"
                      label="Начало действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.first.insurance.doc.date"
                      color="secondary"
                      type="date"
                      label="Срок действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.first.insurance.kasko"
                      color="secondary"
                      label="КАСКО"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item>
              <form>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="form.first.circumstances"
                      :items="dict.circumstances"
                      color="secondary"
                      label="Обстоятельства ДТП"
                      multiple
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="form.first.circumstances_text"
                      label="Обстоятельства со слов водителя"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    v-if="short"
                    cols="12"
                  >
                    <v-text-field
                      v-model="form.first.guilty_name"
                      label="ФИО водителя, причинившего вред"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="form.first.damage_list"
                      :items="dict.damage"
                      color="secondary"
                      label="Повреждения"
                      multiple
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    v-for="(item, index) in form.first.damage"
                    :key="index"
                    cols="12"
                  >
                    <v-row
                      class="mx-auto"
                      justify="space-around"
                    >
                      <v-col cols="11">
                        <v-text-field
                          v-model="item.value"
                          color="secondary"
                          label="Повреждения"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="1">
                        <v-icon
                          :disabled="view"
                          @click="form.first.damage = form.first.damage.filter(a=>a!=item)"
                        >
                          mdi-delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-icon
                      :disabled="view"
                      @click="form.first.damage.push({value: ''})"
                    >
                      mdi-plus
                    </v-icon>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="form.first.hidden"
                      label="Возможны скрытые повреждения"
                      :disabled="view"
                    >
                      mdi-plus
                    </v-checkbox>
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item v-if="!this.short">
              <form>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.second.vehicle.model"
                      required
                      :rules="[(v) => !!v || 'Заполните поле']"
                      color="secondary"
                      label="Марка транспортного средства"
                      prepend-icon="mdi-car"
                      :disabled="view"
                      @input="()=>form.second.vehicle.model = form.second.vehicle.model.toUpperCase()"
                    />
                  </v-col>
                  <v-col
                    v-if="!form.second.vehicle.without_vin"
                    cols="8"
                    md="8"
                  >
                    <v-text-field

                      v-model="form.second.vehicle.vin"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]{17}$/.test(v) || 'VIN должен состоять только из латинских букв и цифр']"
                      required
                      color="secondary"
                      label="VIN"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      :disabled="view"
                      @input="()=>form.second.vehicle.vin = form.second.vehicle.vin.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col
                    v-if="form.second.vehicle.without_vin"
                    cols="8"
                    md="8"
                  >
                    <v-text-field
                      v-model="form.second.vehicle.body"
                      :counter="17"
                      :rules="[(v) => !!v || 'Заполните поле', (v) => /^[0-9A-Z]+$/.test(v) || 'Номер кузова должен состоять только из латинских букв и цифр']"
                      required
                      color="secondary"
                      label="Номер кузова"
                      prepend-icon="mdi-barcode"
                      maxlength="17"
                      :disabled="view"
                      @input="()=>form.second.vehicle.body = form.second.vehicle.body.toUpperCase().substring(0,17)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.second.vehicle.without_vin"
                      color="secondary"
                      label="VIN отсутствует"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.second.vehicle.number"
                      :disabled="form.second.vehicle.without_number || view"
                      color="secondary"
                      label="Госномер"
                      prepend-icon="mdi-barcode-scan"
                      @input="()=>form.second.vehicle.number = form.second.vehicle.number.toUpperCase()"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.second.vehicle.without_number"
                      color="secondary"
                      label="Отсутствует"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.second.vehicle.date"
                      required
                      color="secondary"
                      type="number"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      label="Год выпуска ТС"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="form.second.vehicle.doc_type"
                      required
                      :rules="[(v) => !!v || 'Заполните поле']"
                      :items="dict.doc_type"
                      color="secondary"
                      label="Тип документа"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.second.vehicle.doc.series"
                      required
                      :counter="4"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      color="secondary"
                      label="Серия документа"
                      maxlength="4"
                      prepend-icon="mdi-file-document-box"
                      :disabled="view"
                      @input="()=>form.second.vehicle.doc.series = form.second.vehicle.doc.series.toUpperCase().substring(0,4)"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.second.vehicle.doc.number"
                      required
                      :counter="6"
                      maxlength="6"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{6}$/.test(v) || 'Неверное значение']"
                      color="secondary"
                      label="Номер документа"
                      :disabled="view"
                      @input="()=>form.second.vehicle.doc.number = form.second.vehicle.doc.number.toUpperCase().substring(0,6)"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="form.second.vehicle.doc.date"
                      type="date"
                      label="Дата выдачи"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox
                      v-model="form.second.vehicle.can_move"
                      color="secondary"
                      label="Может ли передвигаться своим ходом?"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-if="!form.second.vehicle.can_move"
                      v-model="form.second.vehicle.cause"
                      color="secondary"
                      label="Почему нет?"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>

            <v-tab-item
              v-if="!this.short"
              class="pb-12"
            >
              <div class="text-center display-2 grey--text font-weight-light mb-6">
                Участник 2. Информация о собственнике ТС.
              </div>

              <form
                action=""
                data-vv-scope="second_owner"
              >
                <v-row
                  class="mx-auto"
                  justify="space-around"
                >
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="form.second.owner.surname"
                      v-validate="'required'"
                      color="secondary"
                      label="Фамилия собственника"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      :disabled="view"
                      @input="()=>form.second.owner.surname=form.second.owner.surname.toUpperCase()"
                    />

                    <v-text-field
                      v-model="form.second.owner.name"
                      v-validate="'required'"
                      color="secondary"
                      label="Имя собственника"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      :disabled="view"
                      @input="()=>form.second.owner.name=form.second.owner.name.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.second.owner.patronymic"
                      v-validate="'required'"
                      color="secondary"
                      label="Отчество собственника"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      :disabled="view"
                      @input="()=>form.second.owner.patronymic=form.second.owner.patronymic.toUpperCase()"
                    />
                    <v-col cols="12">
                      <v-text-field
                        v-model="form.second.owner.phone"
                        color="secondary"
                        type="number"
                        label="Телефон"
                        :counter="11"
                        maxlength="11"
                        :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                        prepend-icon="mdi-face"
                        :mask="'+7(###)###-##-##'"
                        :disabled="view"
                      />
                    </v-col>
                    <v-text-field
                      v-model="form.second.owner.address"
                      v-validate="'required'"
                      name="second_owner_address"
                      color="secondary"
                      label="Адрес регистрации"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item
              v-if="!this.short"
              class="pb-12"
            >
              <div class="text-center display-2 grey--text font-weight-light mb-6">
                Участник 2. Информация о водителе.
              </div>

              <form
                action=""
                data-vv-scope="second_driver"
              >
                <v-row
                  class="mx-auto"
                  justify="space-around"
                >
                  <v-col
                    cols="12"
                  >
                    <v-checkbox
                      v-model="form.second.driver.as_owner"
                      v-validate="'required'"
                      color="secondary"
                      label="Водитель является собственником ТС"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      :disabled="view"
                    />
                    <v-text-field
                      v-model="form.second.driver.surname"
                      v-validate="'required'"
                      :disabled="form.second.driver.as_owner || view"
                      color="secondary"
                      label="Фамилия"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.second.driver.surname=form.second.driver.surname.toUpperCase()"
                    />

                    <v-text-field
                      v-model="form.second.driver.name"
                      v-validate="'required'"
                      :disabled="form.second.driver.as_owner || view"
                      color="secondary"
                      label="Имя"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.second.driver.name=form.second.driver.name.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.second.driver.patronymic"
                      v-validate="'required'"
                      :disabled="form.second.driver.as_owner || view"
                      color="secondary"
                      label="Отчество"
                      prepend-icon="mdi-home"
                      validate-on-blur
                      @input="()=>form.second.driver.patronymic=form.second.driver.patronymic.toUpperCase()"
                    />
                    <v-text-field
                      v-model="form.second.driver.address"
                      v-validate="'required'"
                      name="second_driver_address"
                      :disabled="form.second.driver.as_owner || view"
                      color="secondary"
                      label="Адрес"
                      prepend-icon="mdi-home"
                      validate-on-blur
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.second.driver.birthday"
                      color="secondary"
                      label="Дата рождения"
                      type="date"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.second.driver.phone"
                      color="secondary"
                      type="number"
                      label="Телефон"
                      :counter="11"
                      maxlength="11"
                      :rules="[(v) => /7\d{10}/.test(v) || 'Неверное значение']"
                      prepend-icon="mdi-face"
                      :mask="'7(###)###-##-##'"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    Данные о водительском удостоверении
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.second.driver.driver_doc.series"
                      color="secondary"
                      label="Серия ВУ"
                      prepend-icon="mdi-car"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{4}$/.test(v) || 'Неверное значение']"
                      :counter="4"
                      maxlength="4"
                      :disabled="view"
                      @input="()=>form.second.driver.driver_doc.series = form.second.driver.driver_doc.series.toUpperCase().substring(0,4)"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.second.driver.driver_doc.number"
                      color="secondary"
                      label="Номер ВУ"
                      :counter="6"
                      maxlength="6"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{6}$/.test(v) || 'Неверное значение']"
                      :disabled="view"
                      @input="()=>form.second.driver.driver_doc.number = form.second.driver.driver_doc.number.toUpperCase().substring(0,6)"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.second.driver.driver_doc.date"
                      color="secondary"
                      label="Дата выдачи"
                      type="date"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="form.second.driver.category"
                      :items="dict.category"
                      color="secondary"
                      label="Категория"
                      multiple
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item
              v-if="!this.short"
              class="pb-12"
            >
              <div class="text-center display-2 grey--text font-weight-light mb-6">
                Участник 2. Информация о страховой.
              </div>

              <form
                action=""
                data-vv-scope="second_insurance"
              >
                <v-row
                  class="mx-auto"
                  justify="space-around"
                >
                  <v-col cols="8">
                    <v-select
                      v-model="form.second.insurance.insurer"
                      :items="dict.insurer"
                      color="secondary"
                      label="Страховая"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      color="primary"
                      max-width="100"
                      @click="dialog.insurer.show = true"
                    >
                      Добавить
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.second.insurance.doc.series"
                      color="secondary"
                      label="Серия"
                      prepend-icon="mdi-car"
                      :counter="3"
                      maxlength="3"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{3}$/.test(v) || 'Неверное значение']"
                      :disabled="view"
                      @input="()=>form.second.insurance.doc.series = form.second.insurance.doc.series.toUpperCase().substring(0,3)"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="form.second.insurance.doc.number"
                      color="secondary"
                      label="Номер полиса"
                      :counter="10"
                      maxlength="10"
                      :rules="[(v) => !!v || 'Заполните поле',(v) => /^.{10}$/.test(v) || 'Неверное значение']"
                      :disabled="view"
                      @input="()=>form.second.insurance.doc.number = form.second.insurance.doc.number.toUpperCase().substring(0,10)"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.second.insurance.doc.from_date"
                      color="secondary"
                      type="date"
                      label="Начало действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="form.second.insurance.doc.date"
                      color="secondary"
                      type="date"
                      label="Срок действия"
                      prepend-icon="mdi-car"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="form.second.insurance.kasko"
                      color="secondary"
                      label="КАСКО"
                      :disabled="view"
                    />
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item
              v-if="!this.short"
              class="pb-12"
            >
              <div class="text-center display-2 grey--text font-weight-light mb-6">
                Участник 2. Обстоятельства ДТП.
              </div>

              <form
                action=""
                data-vv-scope="second_common"
              >
                <v-row
                  class="mx-auto"
                  justify="space-around"
                >
                  <v-col cols="12">
                    <v-select
                      v-model="form.second.circumstances"
                      :items="dict.circumstances"
                      color="secondary"
                      label="Обстоятельства ДТП"
                      multiple
                      :disabled="view"
                    />
                  </v-col>
                  <v-col class="colds">
                    <v-textarea
                      v-model="form.second.circumstances_text"
                      label="Обстоятельства со слов водителя"
                      :disabled="view"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="form.second.damage_list"
                      :items="dict.damage"
                      color="secondary"
                      label="Повреждения"
                      multiple
                      :disabled="view"
                    />
                  </v-col>
                  <v-col
                    v-for="(item, index) in form.second.damage"
                    :key="index"
                    cols="12"
                  >
                    <v-row
                      class="mx-auto"
                      justify="space-around"
                    >
                      <v-col cols="11">
                        <v-text-field
                          v-model="item.value"
                          color="secondary"
                          label="Повреждения"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col cols="1">
                        <v-icon
                          :disabled="view"
                          @click="form.second.damage = form.second.damage.filter(a=>a!=item)"
                        >
                          mdi-delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-icon
                      :disabled="view"
                      @click="form.second.damage.push({value: ''})"
                    >
                      mdi-plus
                    </v-icon>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="form.second.hidden"
                      label="Возможны скрытые повреждения"
                      :disabled="view"
                    >
                      mdi-plus
                    </v-checkbox>
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item class="pb-12">
              <form
                action=""
              >
                <div class="text-center display-2 grey--text font-weight-light mb-6">
                  Фотографии
                </div>
                <v-row class="mx-auto">
                  <v-col cols="12">
                    <v-form>
                      <v-container class="py-0">
                        <v-card
                          class="elevation-1"
                          text
                        >
                          <v-progress-linear
                            class="ma-0"
                            color="secondary"
                            :indeterminate="loader.show"
                          />
                          <v-card-text>
                            <!-- <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>Фотографии ДТП</v-expansion-panel-header>
                          <v-expansion-panel-content> -->
                            <v-data-table
                              hide-default-footer
                              hide-default-header
                              :items="form.photos"
                              :headers="table.headers"
                              class="table_photos"
                            >
                              <template v-slot:item.image="{item}">
                                <v-img
                                  max-width="100"
                                  :src="get_src(item.id)"
                                  @click="dialog_photos(item)"
                                />
                              </template>
                              <template v-slot:item.description="{item}">
                                <v-text-field
                                  v-model="item.description"
                                  :disabled="loader.show || view"
                                  label="Описание"
                                />
                              </template>
                              <template v-slot:item.delete="{item}">
                                <v-icon
                                  :disabled="view"
                                  @click="form.photos = form.photos.filter(a=>a!=item)"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                            </v-data-table>
                            <v-btn
                              v-if="form.photos && form.photos.length < 10"
                              color="primary"
                              text
                              :disabled="loader.show || view"
                              @click="$refs.upload.click()"
                            >
                              Добавить файл
                            </v-btn>
                            <!--    </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels> -->
                            <input
                              ref="upload"
                              type="file"
                              multiple="true"
                              style="display: none;"
                              accept="image/*"
                              @change="async_upload_photos"
                            >
                          </v-card-text>
                        </v-card>
                      </v-container>
                    </v-form>
                  </v-col>
                </v-row>
              </form>
            </v-tab-item>
            <v-tab-item>
            <v-form>
              <v-container class="py-0">
                <v-card
                  class="elevation-1"
                  text
                >
                  <v-progress-linear
                    class="ma-0"
                    color="secondary"
                    :indeterminate="loader.show"
                  />
                  <v-card-text>
                    <v-data-table
                      hide-default-footer
                      hide-default-header
                      :items="form.docs.filter(a=>!a.hide)"
                      :headers="table.files"
                    >
                      <template v-slot:item.save="{item}">
                        <v-icon @click="getDoc(item)">
                          mdi-content-save
                        </v-icon>
                      </template>
                      <template v-slot:item.comment="{item}">
                        <v-text-field
                          v-model="item.comment"
                          :disabled="loader.show || view"
                          label="Описание"
                        />
                      </template>
                      <template v-slot:item.type="{item}">
                        <v-select
                          v-model="item.type"
                          :disabled="loader.show || view"
                          label="Тип"
                          :items="select.file_type"
                        />
                      </template>
                      <template v-slot:item.created="{item}">
                        {{format(item.created)}}
                      </template>
                      <template v-slot:item.action="{item}">
                        <v-icon @click="form.docs = form.docs.filter(a=>a!=item)">mdi-delete</v-icon>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions class="grey lighten-4">
                    <v-btn
                      color="primary"
                      text
                      :disabled="loader.show || view"
                      @click="$refs.upload2.click()"
                    >
                      Добавить файл
                    </v-btn>
                    <input
                      ref="upload2"
                      type="file"
                      style="display: none;"
                      @change="upload_file"
                    >
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-tab-item>
          </base-material-tabs>
          <v-card-actions>
            <v-btn color="primary" @click="save(true)" min-width=100 :disabled="load">Сохранить</v-btn>  
            <v-checkbox class="ml-3" v-model="form.generate_files" label="Перегенерация файлов"></v-checkbox>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog.photos.show">
      <v-carousel
        v-model="dialog.photos.slide"
        :continuous="false"
        hide-delimiter-background
        max-height="300"
        color="gray"
        class="carousel_photo"
      >
        <v-carousel-item
          v-for="(item,i) in form.photos"
          :key="i"
          :src="get_src(item.id)"
        >
          <v-row
            class="fill-height"
            align="start"
            justify="end"
          >
            <v-btn
              class="mr-5 mt-2"
              color="primary"
              height="30px"
              tile
              outlined
              :disabled="loader.show"
              @click="open_file(item.id)"
            >
              <v-icon>mdi-download</v-icon><span class="mr-1">Скачать</span>
            </v-btn>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-dialog>
    <v-overlay :value="loader.show">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </div>
</template>

<script>
  import $ from 'jquery'
  //import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import suggest from 'suggestions-jquery'
  import moment from 'moment'
  import { mask, tokens, TheMask } from 'vue-the-mask'

  export default {
    name: 'DashboardFormsWizard',
    components: { TheMask },
    directives: { mask, tokens },
    props: ['create', 'id', 'short', 'view','change'],
    data: () => ({
      upload: {
        angle: 1,
      },
      table: {
        headers: [
          {
            text: 'Изображение',
            value: 'image',
          },
          {
            text: 'Описание',
            value: 'description',
          },
          {
            text: 'Удалить',
            value: 'delete',
          },
        ],
        files: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Дата',
            value: 'created'
          },
          {
            text: 'Описание',
            value: 'comment',
          },
          {
            text: 'Тип',
            value: 'type'
          },
          {
            text: 'Действие',
            value: 'action'
          }
        ]
      },
      loader: {
        show: false,
      },
      load: false,
      hexMask: {
        mask: 'AAAAAA',
      },
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: v => v.toLocaleUpperCase(),
        },
      },
      dictionary: [],
      dialog: {
        insurer: {
          show: false,
          data: {
            name: '',
          },
        },
        photos: {
          show: false,
          slide: 0,
        },
      },
      valid: {
        first: {
          vehicle: false,
        },
        second: {
          vehicle: false,
        },
      },
      title: '',
      form: {
        docs: [],
        photos: [],
        common: {
          address: '',
          date: moment().format('YYYY-MM-DD'),
          time: moment().format('HH:00'),
          count: {
            cars: 2,
            wounded: 0,
            dead: 0,
          },
          drunken: false,
          other_car_damage: false,
          other_damage: false,
          witness: '',
          witness_exists: false,
          inspector: false,
          inspector_number: '',
        },
        first: {
          photo: [],
          hidden: true,
          vehicle: {
            vin: '',
            model: '',
            number: null,
            without_number: false,
            doc_type: 0,
            date: '',
            doc: {
              series: '',
              number: '',
            },
          },
          owner: {
            surname: '',
            name: '',
            patronymic: '',
            address: '',
            address_data: {},
            phone: '',
          },
          driver: {
            as_owner: false,
            surname: '',
            name: '',
            patronymic: '',
            address: '',
            address_data: {},
            driver_doc: {
              series: '',
              number: '',
              date: '',
            },
            category: null,
            birthday: '',
            phone: '',
          },
          insurance: {
            insurer: 0,
            doc: {
              series: '',
              number: '',
              date: '',
            },
            valid: '',
            kasko: false,
          },
          damage: [{ value: '' }],
          damage_list: null,
          circumstances: null,
          circumstances_text: '',
        },
        second: {
          photo: [],
          hidden: true,
          vehicle: {
            vin: '',
            model: '',
            number: null,
            without_number: false,
            doc_type: 0,
            date: '',
            doc: {
              series: '',
              number: '',
            },
          },
          owner: {
            surname: '',
            name: '',
            patronymic: '',
            address: '',
            address_data: {},
            phone: '',
          },
          driver: {
            as_owner: false,
            surname: '',
            name: '',
            patronymic: '',
            address: '',
            address_data: {},
            driver_doc: {
              series: '',
              number: '',
              date: '',
            },
            category: null,
            birthday: '',
            phone: '',
          },
          insurance: {
            insurer: 0,
            doc: {
              series: '',
              number: '',
              date: '',
            },
            valid: '',
            kasko: false,
          },
          damage: [{ value: '' }],
          damage_list: null,
          circumstances: null,
          circumstances_text: '',
          short: false,
        },
      },
      dict: {
        category: [
          { value: 1, text: 'A' },
          { value: 2, text: 'A1' },
          { value: 3, text: 'B' },
          { value: 4, text: 'BE' },
          { value: 5, text: 'B1' },
          { value: 6, text: 'C' },
          { value: 7, text: 'CE' },
          { value: 8, text: 'C1' },
          { value: 9, text: 'C1E' },
          { value: 10, text: 'D' },
          { value: 11, text: 'DE' },
          { value: 12, text: 'D1' },
          { value: 13, text: 'D1E' },
          { value: 14, text: 'M' },
          { value: 15, text: 'Tm' },
          { value: 16, text: 'Tb' },
        ],
        insurer: [],
        circumstances: [],
        doc_type: [
          { value: 1, text: 'Свидетельство о регистрации ТС' },
          { value: 2, text: 'Паспорт ТС' },
          { value: 3, text: 'Паспорт самоходной машины' },
          { value: 4, text: 'Аналогичный документ' },
        ],
        damage: [],
        angle: [],
      },
      select: {
        users: [],
        file_type: [],
      },
      tab: 0,
      tabs: ['Общее', 'ТС A. Информация', 'ТС А. Собственник', 'ТС А. Водитель', 'ТС А. Страховая', 'ТС А. Обстоятельства', 'ТС В. Информация', 'ТС В. Собственник', 'ТС В. Водитель', 'ТС В. Страховая', 'ТС В. Обстоятельства', 'Фото', 'Файлы'],
      suggestions: {
        first_owner_address: {
          enable: false,
        },
        first_driver_address: {
          enable: false,
        },
        second_owner_address: {
          enable: false,
        },
        second_driver_address: {
          enable: false,
        },
      },
    }),

    computed: {
      stringAccount () {
        return this.account.join(',')
      },
    },
    watch: {

    },
    mounted: function () {
      for (let x in this.$store.state.dict.file_type) {
        this.select.file_type.push({ value: Number(x), text: this.$store.state.dict.file_type[x].name })
      }
      if (this.short) {
        this.tabs = ['Общее', 'ТС A. Информация', 'ТС А. Собственник', 'ТС А. Водитель', 'ТС А. Страховая', 'ТС А. Обстоятельства', 'Фото']
        this.form.second = null
      }
      console.log('started')
      this.axios.post('/api/user/get/', {})
        .then(response => {
          if (!response.data.error) {
            this.select.users = response.data.data
            this.form.commissar = this.select.users.find(a => a.id == this.$store.state.user.id)
          }
        })
        .catch(e => {
          console.log(e)
        })
      this.axios.post('/api/common/dictionary/list')
        .then(response => {
          if (!response.data.error) {
            this.dictionary = response.data.data
          } else {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      for (let x in this.$store.state.dict.circumstances) {
        this.dict.circumstances.push({ value: Number(x), text: this.$store.state.dict.circumstances[x].name })
      }
      for (let x in this.$store.state.dict.insurer) {
        this.dict.insurer.push({ value: Number(x), text: this.$store.state.dict.insurer[x].name })
      }
      function damageCompareByPosition (_a, _b) {
        let a = Number(_a.position)
        let b = Number(_b.position)
        if (a > b) return 1
        if (a == b) return 0
        if (a < b) return -1
      }
      for (let x in this.$store.state.dict.damage) {
        this.dict.damage.push({ value: Number(x), text: this.$store.state.dict.damage[x].name, position: this.$store.state.dict.damage[x].position })
      }
      for (let x in this.$store.state.dict.angle) {
        this.dict.angle.push({ value: Number(x), text: this.$store.state.dict.angle[x].name })
      }
      this.dict.damage.sort(damageCompareByPosition)
      this.axios.post('/api/accident/get', { id: this.$route.params.id })
        .then(result => {
          if (!result.data.error) {
            this.form = result.data.data[0]
            this.form.docs = this.form.docs || []
            if (!this.form.second) this.short = true
            if (this.form.first.driver.birthday) this.form.first.driver.birthday = moment(this.form.first.driver.birthday).format('YYYY-MM-DD')
            if (this.form.second) this.form.second.driver.birthday = moment(this.form.second.driver.birthday).format('YYYY-MM-DD')
            if (this.form.first.driver.driver_doc.date) this.form.first.driver.driver_doc.date = moment(this.form.first.driver.driver_doc.date).format('YYYY-MM-DD')
            if (this.form.second) this.form.second.driver.driver_doc.date = moment(this.form.second.driver.driver_doc.date).format('YYYY-MM-DD')
            if (this.form.first.insurance.doc.date) this.form.first.insurance.doc.date = moment(this.form.first.insurance.doc.date).format('YYYY-MM-DD')
            if (this.form.second && this.form.second.insurance.doc.date) this.form.second.insurance.doc.date = moment(this.form.second.insurance.doc.date).format('YYYY-MM-DD')
            if (this.form.first.insurance.doc.from_date) this.form.first.insurance.doc.from_date = moment(this.form.first.insurance.doc.from_date).format('YYYY-MM-DD')
            if (this.form.second && this.form.second.insurance.doc.from_date) this.form.second.insurance.doc.from_date = moment(this.form.second.insurance.doc.from_date).format('YYYY-MM-DD')
            if (this.form.first.vehicle.doc.date) this.form.first.vehicle.doc.date = moment(this.form.first.vehicle.doc.date).format('YYYY-MM-DD')
            if (this.form.second && this.form.second.vehicle.doc.date) this.form.second.vehicle.doc.date = moment(this.form.second.vehicle.doc.date).format('YYYY-MM-DD')
            if (this.short) {
              this.tabs = ['Общее', 'ТС A. Информация', 'ТС А. Собственник', 'ТС А. Водитель', 'ТС А. Страховая', 'ТС А. Обстоятельства', 'Фото']
              this.form.second = null
            }
          }
        })
    },
    methods: {
      format: function(date) {
        if (!date) return ''
        return moment(date).format('DD.MM.YYYY HH:mm')
      },
      getDoc: function (item) {
        console.log(item)
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      upload_file: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          let data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              } else {
                this.form.docs = this.form.docs || []
                for (let x in response.data.data)
                {
                  this.form.docs.push(response.data.data[x])
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      dialog_photos: function (item) {
        this.dialog.photos.slide = this.form.photos.indexOf(item)
        this.dialog.photos.show = true
      },
      open_file: function (item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      get_src: function (id) {
        return '/api/common/document/' + id
      },
      async_upload_photo: async function (file) {
        if (file) {
          let data = new FormData()
          data.append('file', file)
          await this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              } else {
                for (let x in response.data.data) {
                  response.data.data[x].angle = 1
                  this.form.photos.push(response.data.data[x])
                }
              }
            })
            .catch(error => {
              this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
            })
        }
      },
      async_upload_photos: async function (event) {
        const files = event.target.files
        let new_photos_limit = 0
        let msg = ''
        this.loader.show = true
        if ((10 - this.form.photos.length) >= files.length) {
          new_photos_limit = files.length
        } else if (this.form.photos.length < 10) {
          new_photos_limit = 10 - this.form.photos.length
          msg = 'Добавятся не все фотографии (Лимит 10 фотографий)'
        } else {
          msg = 'Лимит 10 фотографий'
        }
        if (new_photos_limit > 0) {
          this.loader.show = true
          for (let i = 0; i < new_photos_limit; i++) {
            await this.async_upload_photo(files[i])
          }
        }
        this.loader.show = false
      },
      upload_photo: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          let data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              } else {
                for (let x in response.data.data) {
                  response.data.data[x].angle = 1
                  this.form.photos.push(response.data.data[x])
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              this.$store.commit('snackbar', error || 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      insurer_add: function () {
        var id = this.dictionary.find(a => a.name == 'insurer').id
        this.axios.post('/api/common/dictionary/add', { id: id, data: { name: this.dialog.insurer.data.name } })
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Данные успешно обновление')
              this.axios.post('/api/common/dictionary/list')
                .then(response => {
                  if (!response.data.error) {
                    this.dictionary = response.data.data
                    let dict = this.dictionary.find(a => a.name == 'insurer')
                    this.dict.insurer = []
                    var filtered = dict.data.filter(a => a.enabled)
                    for (let x in dict.data.filter(a => a.enabled)) {
                      console.log()
                      this.dict.insurer.push({ value: Number(filtered[x].value), text: filtered[x].data.name })
                    }
                    this.dialog.insurer.show = false
                  } else {
                    this.$store.commit('snackbar', 'Ошибка при получении данных')
                  }
                })
                .catch(e => {
                  console.log(e)
                  this.$store.commit('snackbar', 'Ошибка при получении данных')
                })
            } else {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      save: function (stay) {
        this.form.id = this.$route.params.id
        this.load = true
        this.axios.post('/api/accident/update', this.form)
          .then(result => {
            this.load = false
            if (!result.error) {
              this.$store.commit('snackbar', 'Сохранение успешно')
              if (!stay)
              this.$router.push('/accident/list')
            } else {
              this.$store.commit('snackbar', 'Ошибка при сохранении')
            }
          })
          .catch(error => {
            this.load = false
            this.$store.commit('snackbar', 'Ошибка при сохранении')
          })
      },
      next () {
        if (this.load) return
        this.validateForm(this.scope).then(item => {
          if (!item) return
          if (this.tab === this.tabs.length - 1) {
            if (this.create) {
              this.load = true
              this.axios.post('/api/accident/create', this.form)
                .then(result => {
                  this.load = false
                  if (!result.data.error) {
                    if (!this.short) {
                      this.$store.commit('snackbar', 'Создание успешно')
                      this.$router.push('/accident/list')
                    } else {
                      this.$router.push('/contract/create/' + result.data.data.id)
                    }
                  } else {
                    this.$store.commit('snackbar', 'Ошибка при создании')
                  }
                })
                .catch(error => {
                  this.load = false
                  this.$store.commit('snackbar', 'Ошибка при создании')
                })
            } else {
              this.save()
            }
          } else {
            this.tab++
          }
        })
      },
      onChange (val) {
        const value = val.target.files[0]

        if (!value) return (this.image = null)

        this.image = URL.createObjectURL(value)
      },
      validateForm (scope) {
        return this.$validator.validateAll(scope)
      },
    },
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>

<style lang="scss">
  .carousel_photo {
    .v-carousel__item {
      background-color: rgba(0, 0, 0, 0.87);
    }
    .v-image__image {
      background-size: contain;
    }
  }
  .v-data-table {
    &.table_photos {
      tbody {
        tr {
          td {
            &:last-child {
              border-bottom: 0px !important;
            }
            .v-image {
              cursor: pointer;
              margin-bottom: 6px;
              margin-top: 6px;
            }
          }
        }
      }
    }
  }
</style>
